/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 29/07/2025.
 */
import { Button, Progress, Steps } from 'antd'
import React, { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useSyncEvaluator } from '../../../hooks/useSyncEvaluator'
import { DATA_SYNCED } from '../../../hooks/usePhaseConfigEvaluator'
import { wait } from '../../../constants'
import { PollEndpoint } from '../../../components/PollEndpoint'
import AppImg from '../../../assets/device_sync.jpg'
import { ReactComponent as RefreshIcon } from '../../../assets/refresh_icon.svg'
import { RoundSpinner } from '../../../components/spinner/Spinner'

type Props = {
  children?: React.ReactNode
  onClose?: () => void
  outerMutate?: (data: any) => void
  navigateToDeviceNotAvailble?: () => void
}

const delay = 3000
export const InitiateDataSync = ({ children, outerMutate, onClose = () => {}, navigateToDeviceNotAvailble }: Props) => {
  const { projectId, subjectId } = useParams() as { projectId: string; subjectId: string }
  const { data, mutate, path } = useSyncEvaluator(projectId, subjectId)
  const [step, setStep] = useState<number>(0)
  const [useDelay, setUseDelay] = useState<boolean>(false)

  const myMutate = () => {
    setUseDelay(true)
    mutate({ data: 'some' })
  }

  const initiateSyncClick = () => {
    setStep(1)
  }

  const waitAndSetComplete = useCallback(
    (delayDuration) => {
      wait(delayDuration).then(() => {
        if (children) {
          setStep(4)
        } else {
          if (outerMutate) {
            setStep(4)
            outerMutate({ data: null })
          }
        }
      })
    },
    [children, outerMutate]
  )

  const callNavigateToDeviceNotAvilble = () => {
    if (navigateToDeviceNotAvailble) {
      navigateToDeviceNotAvailble()
    }
  }

  useEffect(() => {
    if (data === DATA_SYNCED) {
      setStep(3)
      waitAndSetComplete(useDelay ? delay : 0)
    }
  }, [data, setStep, waitAndSetComplete, useDelay])

  const progress = step === 0 ? 0 : Math.min((step * 100) / 2, 100)

  return (
    <div className="container-fluid" style={{ minWidth: 400 }}>
      {/*This will handle the polling*/}
      {step === 1 ? (
        <PollEndpoint endpoint={path} result={DATA_SYNCED} callback={myMutate} spinnerType="NONE"></PollEndpoint>
      ) : null}

      {step !== 4 ? (
        <div className="row" style={{}}>
          {/*<div className="col-12 d-flex justify-content-center">
            <img src={AppImg} className="w-50" alt="" />
          </div>*/}
          <div className="col-3">
            <img src={AppImg} className="w-100" alt="" />
          </div>
          <div className="col-9 mt-2">
            {step > 2 ? (
              <h3 style={{ color: '#27BE3F' }}>Syncronisation complete</h3>
            ) : (
              <h3 className="fw-bolder">Synchronization Required</h3>
            )}
            {/*<p className="opacity-75">We detected that there might be data on the subjects device</p>*/}
            <p className="opacity-75">
              To proceed with this action, the device must be fully synchronized. Ensure the dataset is up to date
              before continuing. Follow the steps below.
            </p>
          </div>

          {/* <div className="col-12 mt-4">
            {step === 3 ? (
              <div
                className="h-100 w-100 d-flex justify-content-center align-items-center "
                style={{ backgroundColor: 'rgba(255,255,255,.9)' }}
              >
                <div className="d-flex flex-column align-items-center">
                  <CheckCircleOutlined className="mb-3" style={{ fontSize: 60, color: '#52C41A' }} />
                  <h4 style={{ color: '#52C41A' }}>Syncronisation complete</h4>
                </div>
              </div>
            ) : null}
          </div>*/}

          <div className="col-12 mt-4">
            <div className="d-flex justify-content-between">
              <p className="fw-bold mb-0 p-small" style={{ letterSpacing: '0.03rem' }}>
                Progress
              </p>
              <p className="fw-bold mb-0 p-small" style={{ letterSpacing: '0.03rem' }}>
                {progress}%
              </p>
            </div>
            <Progress percent={progress} showInfo={false} status={step === 3 ? 'success' : 'active'} />
          </div>

          <div className="col-12 mt-3 position-relative">
            {/*       {step === 3 ? (
              <div className="position-absolute top-0 left h-100 w-100 " style={{ zIndex: 10 }}>
                <div
                  className="h-100 w-100 d-flex justify-content-center align-items-center "
                  style={{ backgroundColor: 'rgba(255,255,255,.85)' }}
                >
                  <div className="d-flex flex-column align-items-center">
                    <CheckCircleOutlined className="mb-3" style={{ fontSize: 50, color: '#27BE3F' }} />
                    <h4 style={{ color: '#27BE3F' }}>Syncronisation complete</h4>
                  </div>
                </div>
              </div>
            ) : null}*/}

            <div className="border rounded-2 py-3 px-3">
              <div className="mt-1">
                <h4>How to Synchronize</h4>
                <p className="">
                  Use this process to ensure the participant's responses are up-to-date and all device data is
                  synchronized.
                </p>
              </div>

              <div className="mt-4">
                <Steps
                  orientation="vertical"
                  current={step}
                  items={[
                    {
                      title: <p className="fw-bold">Initiate Synchronization</p>,
                      //subTitle: 'Step 1 of 3',
                      content: 'Start by clicking the "Initiate data sync" button below to begin the process.',
                    },
                    {
                      title: (
                        <p className="fw-bold">
                          {step === 1 ? <span className="text-danger">Action required:</span> : null}
                          <span className=""> Open AnneaPRO App</span>
                        </p>
                      ),
                      //status: stepTwoStatus,
                      icon: step === 1 ? <RoundSpinner className="mt-1" size={20}></RoundSpinner> : null,
                      content: (
                        <div className="">
                          <p className="">
                            In the AnneaPRO App, tap the
                            <span
                              className="px-2 mx-1 rounded-2"
                              style={{ background: '#e4e4e4', paddingTop: 2, paddingBottom: 2 }}
                            >
                              <RefreshIcon width={12} height={14} style={{ marginTop: -5 }}></RefreshIcon>
                            </span>
                            icon in the bottom right corner to complete the sync.
                          </p>
                        </div>
                      ),
                    },
                    {
                      title: <p className="fw-bold">Synchronization Complete</p>,
                      content:
                        "All device data has been successfully synchronized. The participants's responses are now up-to-date and ready for processing.",
                    },
                  ]}
                />
              </div>
            </div>
          </div>

          <div className="col-12 mt-3 ">
            <div className="row" style={{}}>
              <div className="col-5">
                {navigateToDeviceNotAvailble ? (
                  <Button onClick={callNavigateToDeviceNotAvilble} type="default" size="large" className="w-100">
                    Device Unavailable
                  </Button>
                ) : null}
              </div>
              <div className="col-7">
                {step === 0 ? (
                  <Button type="primary" size="large" onClick={initiateSyncClick} className="w-100">
                    Initiate Data Sync
                  </Button>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {step === 4 ? children : null}
    </div>
  )
}
